import parse from 'html-react-parser';
import styles from './stickyHeader.module.scss';

export default function StickyHeader({ stickyHeader }) {
  return <header className={styles.stickyHeader}>{parse(stickyHeader)}</header>;
}
